
function Adatvedelem() {



    return (

        <>

            <section>

                <h1>Adatvédelem</h1>
                <p>Az adatvédelmünk fontos számunkra, és az alábbiakban részletezzük, hogy milyen adatokat gyűjtünk, hogyan használjuk fel azokat, valamint milyen intézkedéseket hozunk az adatvédelem biztosítása érdekében. Kérjük, olvasd el figyelmesen az alábbi információkat:</p>

                <h2>Gyűjtött adatok</h2>

                <ul>
                    <li>a. Az oldalunk használata során olyan személyes adatokat gyűjthetünk, mint például az IP-cím, a böngésző típusa, a felhasználói eszköz információi, a böngészési időpontok, valamint az általad beküldött fordítási kérések és szövegek.</li>
                    <li>b. Az oldalunkon sütiket (cookie-kat) használunk, amelyek segítenek az oldal működésében, a felhasználói élmény javításában, valamint az adatok elemzésében és statisztikák készítésében.</li>
                </ul>


                <h2>Adatfelhasználás és tárolás</h2>

                <ul>
                    <li>a. Az általunk gyűjtött személyes adatokat kizárólag az oldalunk működtetéséhez és a szolgáltatásaink nyújtásához használjuk fel.</li>
                    <li>b. Az adatokat biztonságos környezetben tároljuk és megfelelő technikai és szervezési intézkedéseket hozunk az adatok védelme érdekében.</li>
                </ul>


                <h2>Harmadik felek</h2>

                <ul>
                    <li>a. Nem osztunk meg semmilyen személyes adatot harmadik felekkel, hacsak nem vagyunk jogszabály vagy hatósági intézkedés alapján kötelezve erre.</li>
                    <li>b. Az oldalunkon található linkek harmadik fél webhelyeire vezethetnek, és ezekre a webhelyekre vonatkozó adatvédelmi gyakorlatokért nem vállalunk felelősséget.</li>
                </ul>


                <h2>Felhasználói jogok</h2>

                <ul>
                    <li>a. Jogod van hozzáférni a rólad gyűjtött személyes adatokhoz, azokat módosítani vagy törölni.</li>
                    <li>b. Ha szeretnéd visszavonni az adatok gyűjtésére és felhasználására vonatkozó hozzájárulásodat, kérjük, lépj kapcsolatba velünk az alábbi elérhetőségeken.</li>
                </ul>

                <h2>Gyermekek adatvédelme</h2>

                <p>Az oldalunkat nem szánk gyermekeknek, és nem gyűjtünk szándékosan személyes adatokat 18 év alatti személyektől. Ha tudomásunkra jut, hogy gyermekek személyes adatait gyűjtöttük, azokat azonnal töröljük.</p>

                <p>Az adatvédelmi nyilatkozat elfogadásával hozzájárulsz a személyes adataid gyűjtéséhez és felhasználásához az itt leírtak szerint. Adataid védelme és biztonsága kiemelt fontosságú számunkra, és minden tőlünk telhetőt megteszünk az adatvédelem biztosítása érdekében.</p>

                <p>Ha kérdéseid vannak az adatvédelmi gyakorlatunkkal kapcsolatban, vagy ha szeretnél élni a felhasználói jogaidkal, kérjük, lépj kapcsolatba velünk az alábbi elérhetőségeken.</p>

            </section>

        </>


    )
}


export default Adatvedelem;